module.exports = __webpack_public_path__ + "img/fixpel__logo.798d15e6.png";